import { addListType } from './actionTypes';

/* eslint-disable import/prefer-default-export */
export const addListActionFactory = contentTypeId => list => ({
  type: addListType(contentTypeId),
  payload: list,
});
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/store/contentfulRedux/factories/actions.js